import Vue from 'vue'
Vue.prototype.$appInfo = {
  name: 'INSEG', name1: 'INSEG', slogan: '-', description: 'Centro de formacion de seguridad.', version: '1.0.0', autor: 'INSEG',
  icon: require('@/assets/default/is1.svg'),
  icon2: require('@/assets/default/is2-white.svg'),
  celular: "",
  links: [
    {
      name: 'facebook',
      icon: 'mdi-facebook',
      link: 'https://www.facebook.com/moba.tic.ec',
      info: 'Interactua con nuestas publicaciones sociales.',
    },
    {
      name: 'twitter',
      icon: 'mdi-twitter',
      link: '',
      info: '',
    },
    {
      name: 'linkedin',
      icon: 'mdi-linkedin',
      link: '',
      info: '',
    },
    {
      name: 'instagram',
      icon: 'mdi-instagram',
      link: 'https://www.instagram.com/moba.tic.ec/',
      info: '',
    },
  ]
  ,
  keywords: ['inseg', 'centro', 'formacion', 'seguridad', 'cec', 'ecuador']
},
  Vue.prototype.$contactos = {
    direccion: "Calle Principal #123, Ciudad, País",
    telefono: "0985644444",
    email: "email@gmail.com",
    horario_atencion_dia: "Lunes a Viernes",
    horario_atencion_horas: "08h00 a 17h00",
    accesibilidad: "Este sitio cumple con estándares de accesibilidad. Está diseñado para ofrecer una navegación clara, intuitiva y compatible con distintos dispositivos, facilitando el acceso a la información para todos los usuarios.",
    accesibilidadx: "Este sitio cumple con estándares de accesibilidad para personas con discapacidad visual y auditiva."
  }
Vue.prototype.$ajustes = {
  textoLogoCorto: "ABC",
  textoLogoLargo: "INSTITUTO ABC",
  textoLogoSlogan: "",
  textoMotivacion: "",
  colorTextoLogo: "",
  colorTexto1: "",
  colorTexto2: "",
  colorCabecera: "",
  colorPie: "",
  colorDegradado: 0,
  colorSuperior: "",
  colorInferior: "",
  colorElemento: "",
  enlaceVideo1: "",
  enlaceVideo2: "",
  videoUso: 1,
  textoPie: "",
  linkFacebook: "",
  linkInstagram: "",
  linkEmail: "",
  linkWhatsapp: "",
},
  Vue.prototype.$instituto = {
    mision: "ABC",
    vision: "INSTITUTO ABC",
    historia: ""
  }
Vue.prototype.$slogans = {
  slogan1: "El foco que necesitas, en solo una hora.",
  slogan2: "Anuncia rápido, destaca al instante.",
  slogan3: "Tu anuncio al mundo, por 60 minutos.",
  slogan4: "Impacta en una hora, conecta de inmediato.",
  slogan5: "Una hora para brillar, un mundo para mirar.",
}
Vue.prototype.$lastUpdateDate = "23-ENE-2025"
Vue.prototype.$changes = [{
  date: "09-ABR-2025", changes: [
    "Ahora se puede habilitar el uso remoto mediante QR.",
    "Se pueden eliminar las notas de una libreta.",
  ]
},
{
  date: "08-ABR-2025", changes: [
    "Nueva Funcion: crear notas y compartirlas mediante codigos."
  ]
}
];
Vue.prototype.$func = { openDialog: null, name: null }
Vue.prototype.$function = {}
Vue.prototype.$author = { id: '', username: '', name: '', lastname: '', email: '', country: '', avatar: '', occupation: '', datebirth: '', dateCreated: '', lastDateUpdated: '' }
Vue.prototype.$location = 'es'
Vue.prototype.$salesman = { name: 'Don Code', contact: '967267405' }
Vue.prototype.$monthSig = [
  { text: "ene", value: "01" },
  { text: "feb", value: "02" },
  { text: "mar", value: "03" },
  { text: "abr", value: "04" },
  { text: "may", value: "05" },
  { text: "jun", value: "06" },
  { text: "jul", value: "07" },
  { text: "ago", value: "08" },
  { text: "sep", value: "09" },
  { text: "oct", value: "10" },
  { text: "nov", value: "11" },
  { text: "dic", value: "12" },
]

Vue.prototype.$countrys = [
  'Argentina',
  'Australia',
  'Canada',
  'Chile',
  'Colombia',
  'Danmark',
  'Deutschland',
  'Ecuador',
  'España',
  'France',
  'Ireland',
  'Italia',
  'Nederland',
  'New Zealand',
  'Norge',
  'Polska',
  'Schweiz',
  'Sverige',
  'Suomi',
  'United Kingdom',
  'United States',
  'Venezuela',
  '日本 (Nihon)',
  '대한민국 (Hanguk)',
  'Ísland'
]
Vue.prototype.$color = {
  primary: '#40cfff',
  secondary: '#1a1d48',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  gray: '#b9b9b9'
}
Vue.prototype.$portadaLibros= require('@/assets/default/book.png')
Vue.prototype.$datosBibliotecas = [
  {
    categoriaId: "biblio001", categoria: "Ciberseguridad", portada: require('@/assets/default/book.png'), enlace:'https://welib.org/search?page=1&q=Ciberseguridad', activo: true, destacado: true, libros: [
      { libroId: 'book1', titulo: 'Modelo estructural de los observatorios de ciberseguridad: Perspectiva desde la dinámica de sistemas', autor: 'Diego Javier Parada Serrano, Angélica Flórez, Abril Urbano Eliécer Gómez Prada', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fuserbooks%2F05b458a0ba4c6e69b1a4a4726c11796630c0fd82e2e7bfc558741f22c6ea13cb.jpg&md5=e094a2171e395f8a8694c5f686514628&key=yhQZ-bAq2cJY5KDNWarLrQ', enlace: 'https://welib.org/md5/e094a2171e395f8a8694c5f686514628', activo: true, destacado: true },
      { libroId: 'book2', titulo: 'Metamorfosis del Estado. Maremoto digital y ciberseguridad', autor: 'Fuertes Lpez, Mercedes', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fuserbooks%2F45d5cbfb6e6471bbb6227c1209ebb9e2caf58f4b846ff333b7c3493cbccd1d8a.jpg&md5=c2fc1d54782bf764f3babba5357641eb&key=9MsI-AOuGoIdvR9vZP7-2Q', enlace: 'https://welib.org/md5/c2fc1d54782bf764f3babba5357641eb', activo: true, destacado: true },
      { libroId: 'book3', titulo: 'Ciberseguridad para la i-generación', autor: 'Nikki Giant', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fuserbooks%2F3d19eba68498d46ee3eb656fd9d936592aed73a67bfec7dcf7288f3a36cfe3e9.jpg&md5=a28477b098c1ad762cf0296e71290faa&key=L53u_2sVJwRrBl18s5fH9g', enlace: 'https://welib.org/md5/a28477b098c1ad762cf0296e71290faa', activo: true, destacado: true },
      { libroId: 'book4', titulo: 'Ciberseguridad para la i-generación: Usos y riesgos de las redes sociales y sus aplicaciones', autor: 'Nikki Giant [Giant, Nikki]', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fuserbooks%2F336f887d46416a3b216735ed25c43fafbb7c254eda6c5ea7a357d6e36728d0a7.jpg&md5=bea0cfbeecb4ae526eff1cf65d85bd43&key=4HL9-E-IY3-SaetjTrbcBQ', enlace: 'https://welib.org/md5/bea0cfbeecb4ae526eff1cf65d85bd43', activo: true, destacado: true },
      { libroId: 'book5', titulo: 'Ciberseguridad', autor: 'David Arroyo Guardeño, Víctor Gayoso Martínez, Luis Hernández Encinas', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Flibgen.is%2Fcovers%2F4194000%2F38180c7181b5313032e9c5d6d30fadb6-g.jpg&md5=38180c7181b5313032e9c5d6d30fadb6&key=wEB65NnaHwSAS7_7vpZUbA', enlace: 'https://welib.org/md5/38180c7181b5313032e9c5d6d30fadb6', activo: true, destacado: true },
    ],
  },
  {
    categoriaId: "biblio002", categoria: "Logística, transporte y seguridad vial", portada: require('@/assets/default/book.png'), enlace:'https://welib.org/search?page=1&q=transporte+y+seguridad+vial', activo: true, destacado: true, libros: [
      { libroId: 'book6', titulo: 'Educación para la seguridad vial : hacer reforma', autor: 'Violeta Manso Pérez, Manuel Castaño Pardo', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Farchive.org%2Fdownload%2Feducacinparala00mans%2F__ia_thumb.jpg&md5=b766e666c9e759bde0a27bf690f60a99&key=L0lwBC4WCq23vZV1XyD8kg', enlace: 'https://welib.org/md5/b766e666c9e759bde0a27bf690f60a99', activo: true, destacado: true },
      { libroId: 'book7', titulo: 'Ley Nacional De Transito Y Seguridad Vial 2011 (argentina Compilador Federik)', autor: 'Varios', portada: '', enlace: '', activo: true, destacado: true },
    ],
  },
  {
    categoriaId: "biblio003", categoria: "Seguridad y salud ocupacional", portada: require('@/assets/default/book.png'), enlace:'https://welib.org/search?page=1&q=Seguridad+y+salud+ocupacional', activo: true, destacado: true, libros: [
      { libroId: 'book11', titulo: 'Diccionario de Términos de Seguridad y Salud Ocupacional (Español - Inglés)', autor: 'Tomas Schwabe', portada: '', enlace: 'https://welib.org/md5/33cf5f3b29847d9210845176e3b7b40e', activo: true, destacado: true },
      { libroId: 'book12', titulo: 'Seguridad Y Salud en El Trabajo: Conceptos Básicos: Tercera Edición', autor: 'Fernando Henano Robledo', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fuserbooks%2Fef9a584a313cb9cbcfc319b38ce36b136bb5c45a528e01065c839203ae9814d5.jpg&md5=3f7c4631ae475d0bfc6474caa63ec2de&key=VlRBfM-gCFsSd7ez5akGcg', enlace: 'https://welib.org/md5/3f7c4631ae475d0bfc6474caa63ec2de', activo: true, destacado: true },
      { libroId: 'book13', titulo: 'Seguridad ocupacional (6ta edición)', autor: 'Raúl Felipe Trujillo Mejía', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fgenesis%2F3db1596b561927be94155fe3d47d85c7b8694f3b302cdad3ea7010e553067660.jpg&md5=a6ea48bb4913a5e60834cdf5693ad523&key=qsMwowCbuG3ccpOWP8aPnw', enlace: 'https://welib.org/md5/a6ea48bb4913a5e60834cdf5693ad523', activo: true, destacado: true },
      { libroId: 'book14', titulo: 'Sistema de gestión de riesgos en seguridad y salud en el trabajo. Paso a paso para el diseño práctico del SG-SST. 2da Edición', autor: 'Efraín Butrón Palacio', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fgenesis%2Ff2d11108d8e93511be3e17975b23a2c9456e013d114b2a141ba1cd2c2e01adbe.jpg&md5=99eab46e7f0eedafdf25aeadab4c098b&key=9ZEuMoWnCO930UwBw-eEyg', enlace: 'https://welib.org/md5/99eab46e7f0eedafdf25aeadab4c098b', activo: true, destacado: true },
      { libroId: 'book15', titulo: 'Salud Mental Positiva Ocupacional: Investigaciones Actuales y consideraciones teórico conceptuales 1', autor: 'Julio César Vázquez-Colunga', portada: 'https://s2.welib-public.org/covers/proxy?url=https%3A%2F%2Fs3proxy.cdn-zlib.sk%2F%2Fcovers299%2Fcollections%2Fuserbooks%2F488de6557ef4034cb204c75334380248c20c7d4c36ba406571c7f648d57eb5d0.jpg&md5=2e6004388cb5072270519ae8667590c0&key=EgCZKgzbYzYDk_emaeN1Iw', enlace: 'https://welib.org/md5/2e6004388cb5072270519ae8667590c0', activo: true, destacado: true },
    ],
  },
]
Vue.prototype.$highlighted = null
Vue.prototype.$notification = [
  { userId: "339112342287", publicationId: "00cee31123", do: "newlike" }
]
Vue.prototype.$helps = [
  { id: 'ssdsd', title: 'Como publicar un libro', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
  { id: 'esfghf', title: 'Como un libro', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica, Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica, Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica, Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica, Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
  { id: 'ssdsd', title: 'Como dejar todo listo', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
  { id: 'sdse', title: 'Renombrar un texto', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
  { id: 'ddsbv', title: 'Reiniciar un texto', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
  { id: 'tyuujj', title: 'Renombrar un texto', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
  { id: '3werrr', title: 'Cambiar un texto', text: 'Para publicar un libro se necesita realizar primero una pagina y compartirla de forma publica' },
]
Vue.prototype.$genDate = () => {
  var today = new Date();
  return (today.getDate() +
    '/' +
    (today.getMonth() + 1) +
    '/' +
    today.getFullYear() +
    ' ' +
    today.getHours() +
    ':' +
    today.getMinutes() +
    ':' +
    today.getSeconds() +
    ':' + today.getMilliseconds())
}
Vue.prototype.$ponerAjustes = function (aux) {
  this.$ajustes.textoLogoCorto = aux.textoLogoCorto;
  this.$ajustes.textoLogoLargo = aux.textoLogoLargo;
  this.$ajustes.textoLogoSlogan = aux.textoLogoSlogan;
  this.$ajustes.textoMotivacion = aux.textoMotivacion;
  this.$ajustes.colorTextoLogo = aux.colorTextoLogo;
  this.$ajustes.colorTexto1 = aux.colorTexto1;
  this.$ajustes.colorTexto2 = aux.colorTexto2;
  this.$ajustes.colorCabecera = aux.colorCabecera;
  this.$ajustes.colorPie = aux.colorPie;
  this.$ajustes.colorDegradado = aux.colorDegradado;
  this.$ajustes.colorSuperior = aux.colorSuperior;
  this.$ajustes.colorInferior = aux.colorInferior;
  this.$ajustes.colorElemento = aux.colorElemento;
  this.$ajustes.enlaceVideo1 = aux.enlaceVideo1;
  this.$ajustes.enlaceVideo2 = aux.enlaceVideo2;
  this.$ajustes.videoUso = aux.videoUso;
  this.$ajustes.audio = aux.audio;
  this.$ajustes.textoPie = aux.textoPie;
  this.$ajustes.linkFacebook = aux.linkFacebook;
  this.$ajustes.linkInstagram = aux.linkInstagram;
  this.$ajustes.linkEmail = aux.linkEmail;
  this.$ajustes.linkWhatsapp = aux.linkWhatsapp;
};
Vue.prototype.$ponerAjustesRecomendado = function () {
  this.$ajustes = this.$AjustesRecomendado()
};
Vue.prototype.$AjustesRecomendado = function () {
  var _default = {}
  _default.textoLogoCorto = "ABC";
  _default.textoLogoLargo = "INSTITUTO DE ABC/nY EDUCACION UNIVERSAL";
  _default.textoLogoSlogan = "Formamos con excelencia,/nguiamos con propósito";
  _default.textoMotivacion = "Formamos con excelencia,/nguiamos con propósito";
  _default.textoLogo = "Formamos con excelencia,/nguiamos con propósito";
  _default.colorTextoLogo = "#FFFFFF";
  _default.colorTexto1 = "#FFFFFF";
  _default.colorTexto2 = "#11476B";
  _default.colorCabecera = "#11476B";
  _default.colorPie = "#11476b";
  _default.colorDegradado = 0;
  _default.colorSuperior = "#FFFFFF";
  _default.colorInferior = "#FCFCFC";
  _default.colorElemento = "#F4F4F0";
  _default.enlaceVideo1 = "https://www.youtube.com/";
  _default.enlaceVideo2 = "https://www.youtube.com/";
  _default.videoUso = 1;
  _default.audio = 0;
  _default.textoPie = "INSTITUTO DE ABC Y EDUCACIÓN UNIVERSAL";
  _default.linkFacebook = "https://www.facebook.com/";
  _default.linkInstagram = "https://www.instagram.com/";
  _default.linkEmail = "email@email.com";
  _default.linkWhatsapp = "https://web.whatsapp.com/";
  return _default
};
Vue.prototype.$InstitutoRecomendado = function () {
  var _default = {}
  _default.historia = "Desde su fundación en 2025, el Instituto ha liderado la formación técnica en seguridad y transporte. Con una visión de progreso, ha consolidado alianzas con sectores públicos y privados para mejorar la movilidad y la seguridad vial en el país.",
    _default.mision = "Formar profesionales altamente capacitados en seguridad y transporte, con valores éticos, sentido de responsabilidad social y compromiso con la innovación y el desarrollo sostenible.",
    _default.vision = "Ser reconocidos como el instituto líder en educación técnica en seguridad y transporte, promoviendo la excelencia académica, la ética profesional y el desarrollo integral de nuestros estudiantes.",
    _default.valores = ["Ética", "Innovación", "Trabajo en equipo", "Excelencia"],
    _default.imagenes_rutas = [
      require('@/assets/default/is2.svg'),
      require('@/assets/default/is2.svg'),
      require('@/assets/default/is2.svg'),
      require('@/assets/default/is2.svg'),
    ]
  return _default
}
Vue.prototype.$test = (data) => {
  alert('Data: ' + data)
}
Vue.prototype.$textoFormateado = (texto) => {
  if (typeof texto !== 'string') return '';

  return texto
    .replace(/\\n|\n/g, '<br>')                   // salto de línea
    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')      // *negrita*
    .replace(/~([^~]+)~/g, '<em>$1</em>')                   // ~cursiva~
    .replace(/_([^_]+)_/g, '<u>$1</u>');
}